/* tslint:disable jsx-no-lambda */
import * as classNames from 'classnames'
import * as React from 'react'
import IconArrowLeft from '../icons/ui/IconArrowLeft'
import IconArrowRight from '../icons/ui/IconArrowRight'

interface IReactTablePaginationProps {
  page: number
  pages: number
  pageSize: number
  canNext: boolean
  canPrevious: boolean
  totalCount?: number
  rowCount?: number
  previousPage: () => void
  nextPage: () => void
  setPageSize?: (value: number) => void
}

const ReactTablePagination = (props: IReactTablePaginationProps) => {
  const { canPrevious, page, pages, canNext, previousPage, nextPage, pageSize, rowCount, totalCount } = props

  const handlePrevClick = () => {
    if (!canPrevious) {
      return
    }
    previousPage()
  }

  const handleNextClick = () => {
    if (!canNext) {
      return
    }
    nextPage()
  }
  const displayPage = page + 1
  return (
    <div className='flex justify-between items-center mt3'>
      <div className='h5 font-grey2'>
        {props.setPageSize && (
          <div className='pb1'>
            {' '}
            Rows per view
            <span className='ml1'>
              <select
                value={pageSize}
                onChange={e => {
                  if (props.setPageSize) {
                    props.setPageSize(Number(e.target.value))
                  }
                }}
              >
                {[10, 25, 50, 100].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </span>
          </div>
        )}

        {rowCount !== undefined && (
          <div className='pb1'>
            Total records on this page: <span className='h5 font-dark-grey'>{rowCount}</span>
          </div>
        )}
        {totalCount !== undefined && (
          <div className='pb1'>
            Total records found: <span className='font-dark-grey'>{totalCount}</span>
          </div>
        )}
        <div>
          Page {displayPage} of {pages || displayPage}
        </div>
      </div>
      <div className='flex'>
        <div onClick={handlePrevClick} className='cursor--pointer p1 mr3'>
          <IconArrowLeft
            className={classNames({
              'icon--16x16': true,
              'svg-fill-green': canPrevious
            })}
          />
        </div>
        <div onClick={handleNextClick} className='cursor--pointer p1'>
          <IconArrowRight
            className={classNames({
              'icon--16x16': true,
              'svg-fill-green': canNext
            })}
          />
        </div>
      </div>
    </div>
  )
}

export default ReactTablePagination



// WEBPACK FOOTER //
// ./src/components/ui/ReactTablePagination.tsx